<div
  class="tw--m-4 tw-flex tw-min-h-[calc(100%+2rem)] tw-w-[calc(100%+2rem)] tw-bg-color-surface-page tw-p-4 sm:tw-m-0 sm:tw--mt-2 sm:tw-min-h-[calc(100dvh_-_var(--app-menu-height,0px))] sm:tw-w-full sm:tw-p-0"
>
  <div class="tw-flex tw-h-full tw-w-full tw-flex-col">
    <div
      class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-py-4 sm:tw-gap-2"
    >
      <span class="tw-whitespace-nowrap tw-text-2xl tw-font-medium tw-text-color-text-default">
        {{ "accounts" | i18n }}
      </span>
      <div
        class="tw-order-2 tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-end sm:tw-order-3 sm:tw-basis-full"
      >
        @if (!showAccountsSkeleton()) {
          <div class="tw-relative tw-min-w-0 tw-flex-1">
            <div
              appGlossScroll
              #statsScroll
              class="tw-flex tw-items-center tw-gap-3 sm:tw-gap-2 tw-overflow-x-auto tw-scroll-smooth tw-px-2 tw--mx-2 tw-py-2 tw--my-2 auto-hide-scrollbar"
              (scroll)="updateStatsScrollArrows()"
            >
              <div
                class="tw-flex tw-shrink-0 tw-cursor-pointer tw-flex-col tw-items-center tw-text-center tw-min-w-[90px] tw-px-4 tw-py-3 sm:tw-px-1 sm:tw-py-2 tw-rounded-xl tw-bg-dt-surface-input tw-shadow-card-elevated tw-transition-[width] tw-duration-200"
                [ngClass]="
                  !expandedStat() ? 'sm:tw-min-w-0 sm:tw-flex-1 sm:tw-basis-0 sm:tw-shrink' : ''
                "
                (click)="toggleExpandedStat('netWorth', $event)"
              >
                <span
                  class="tw-text-lg sm:tw-text-sm tw-font-semibold tw-whitespace-nowrap"
                  [ngClass]="{
                    'tw-text-dt-text-in-primary': netWorth() > 0.01,
                    'tw-text-dt-text-headings': netWorth() >= -0.01 && netWorth() <= 0.01,
                    'tw-text-dt-text-error': netWorth() < -0.01,
                  }"
                  >{{
                    expandedStat() === "netWorth"
                      ? (netWorth() | number: "1.0-0")
                      : (netWorth() | macroNumber)
                  }}</span
                >
                <span
                  class="tw-text-xs tw-uppercase tw-text-dt-text-secondary tw-whitespace-nowrap sm:tw-whitespace-normal sm:tw-text-[9px] sm:tw-leading-tight"
                  >{{ "netWorth" | i18n }}</span
                >
              </div>
              <div
                class="tw-flex tw-shrink-0 tw-cursor-pointer tw-flex-col tw-items-center tw-text-center tw-min-w-[90px] tw-px-4 tw-py-3 sm:tw-px-1 sm:tw-py-2 tw-rounded-xl tw-bg-dt-surface-input tw-shadow-card-elevated tw-transition-[width] tw-duration-200"
                [ngClass]="
                  !expandedStat() ? 'sm:tw-min-w-0 sm:tw-flex-1 sm:tw-basis-0 sm:tw-shrink' : ''
                "
                (click)="toggleExpandedStat('totalAssets', $event)"
              >
                <span
                  class="tw-text-lg sm:tw-text-sm tw-font-semibold tw-whitespace-nowrap"
                  [ngClass]="{
                    'tw-text-dt-text-in-primary': totalAssets() > 0.01,
                    'tw-text-dt-text-headings': totalAssets() >= -0.01 && totalAssets() <= 0.01,
                    'tw-text-dt-text-error': totalAssets() < -0.01,
                  }"
                  >{{
                    expandedStat() === "totalAssets"
                      ? (totalAssets() | number: "1.0-0")
                      : (totalAssets() | macroNumber)
                  }}</span
                >
                <span
                  class="tw-text-xs tw-uppercase tw-text-dt-text-secondary tw-whitespace-nowrap sm:tw-whitespace-normal sm:tw-text-[9px] sm:tw-leading-tight"
                  >{{ "totalAssets" | i18n }}</span
                >
              </div>
              <div
                class="tw-flex tw-shrink-0 tw-cursor-pointer tw-flex-col tw-items-center tw-text-center tw-min-w-[90px] tw-px-4 tw-py-3 sm:tw-px-1 sm:tw-py-2 tw-rounded-xl tw-bg-dt-surface-input tw-shadow-card-elevated tw-transition-[width] tw-duration-200"
                [ngClass]="
                  !expandedStat() ? 'sm:tw-min-w-0 sm:tw-flex-1 sm:tw-basis-0 sm:tw-shrink' : ''
                "
                (click)="toggleExpandedStat('totalLiabilities', $event)"
              >
                <span
                  class="tw-text-lg sm:tw-text-sm tw-font-semibold tw-text-dt-text-error tw-whitespace-nowrap"
                  >{{
                    expandedStat() === "totalLiabilities"
                      ? (totalLiabilities() | number: "1.0-0")
                      : (totalLiabilities() | macroNumber)
                  }}</span
                >
                <span
                  class="tw-text-xs tw-uppercase tw-text-dt-text-secondary tw-whitespace-nowrap sm:tw-whitespace-normal sm:tw-text-[9px] sm:tw-leading-tight"
                  >{{ "totalLiabilities" | i18n }}</span
                >
              </div>
              <div
                class="tw-flex tw-shrink-0 tw-flex-col tw-items-center tw-text-center tw-min-w-[90px] tw-px-4 tw-py-3 sm:tw-px-1 sm:tw-py-2 tw-rounded-xl tw-bg-dt-surface-input tw-shadow-card-elevated"
                [ngClass]="
                  !expandedStat() ? 'sm:tw-min-w-0 sm:tw-flex-1 sm:tw-basis-0 sm:tw-shrink' : ''
                "
              >
                <span class="tw-text-lg sm:tw-text-sm tw-font-semibold tw-text-dt-text-headings">{{
                  accountCount()
                }}</span>
                <span
                  class="tw-text-xs tw-uppercase tw-text-dt-text-secondary tw-whitespace-nowrap sm:tw-whitespace-normal sm:tw-text-[9px] sm:tw-leading-tight"
                  >{{ "totalAccounts" | i18n }}</span
                >
              </div>
            </div>

            @if (canScrollStatsLeft()) {
              <button
                type="button"
                aria-label="Scroll left"
                class="tw-hidden sm:tw-flex tw-absolute tw-left-0 tw-top-1/2 tw--translate-y-1/2 tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-surface-input tw-shadow-card-elevated"
                (click)="scrollStats(-1)"
              >
                <icon name="left-arrow" [size]="4"></icon>
              </button>
            }
            @if (canScrollStatsRight()) {
              <button
                type="button"
                aria-label="Scroll right"
                class="tw-hidden sm:tw-flex tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2 tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-surface-input tw-shadow-card-elevated"
                (click)="scrollStats(1)"
              >
                <icon name="right-arrow" [size]="4"></icon>
              </button>
            }
          </div>
        }
      </div>

      <app-signal-glow-wrapper
        class="tw-order-3 tw-shrink-0 sm:tw-order-2"
        adjustmentClasses="tw-rounded-2xl"
        [isSignal]="signalGlowService.isSignal()"
      >
        <!-- Plain button, not app-gloss-button: that component always renders text before
             the icon with no way to reorder, but the design wants the "+" before the text. -->
        <button
          type="button"
          class="border-gradient-teal tw-shadow-manage-accounts tw-flex tw-h-10 tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-full tw-bg-dt-custom-teal-11 tw-px-4 sm:tw-px-6 tw-text-sm tw-font-medium tw-text-white"
          data-testid="accounts-add-account"
          [attr.aria-label]="'addAccount' | i18n"
          (click)="openAccountCreateModal()"
        >
          <icon name="add" [size]="4" [currentColor]="'white'"></icon>
          <span class="sm:tw-hidden">{{ "addAccount" | i18n }}</span>
        </button>
      </app-signal-glow-wrapper>
    </div>

    <div class="tw-mb-3">
      @if (!showAccountsSkeleton()) {
        <div class="tw-flex tw-items-center tw-gap-3 tw-py-3 tw-rounded-xl tw-bg-dt-surface-input">
          <span class="tw-text-xs tw-text-dt-text-secondary tw-whitespace-nowrap"
            >{{ leverageRate() }}% {{ "percentLeveraged" | i18n }}</span
          >
          <div class="tw-flex-1 tw-h-2 tw-rounded-full tw-bg-dt-neutral-300 tw-overflow-hidden">
            <div
              class="tw-h-full tw-rounded-full tw-bg-dt-warning-500"
              [style.width.%]="leverageRate()"
            ></div>
          </div>
          @if (accountsNeedingAttention() > 0) {
            <span class="tw-text-xs tw-font-medium tw-text-dt-text-error tw-whitespace-nowrap"
              >{{ accountsNeedingAttention() }} {{ "accountsNeedAttention" | i18n }}</span
            >
          }
        </div>
      }

      <div
        class="tw-mt-2 tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-text-xs tw-text-dt-text-secondary"
      >
        <span class="tw-flex tw-items-center tw-gap-1.5">
          <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-success-500"></span>
          {{ "fetched" | i18n }}
        </span>
        <span class="tw-flex tw-items-center tw-gap-1.5">
          <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-warning-500"></span>
          {{ "fetching" | i18n }}
        </span>
        <span class="tw-flex tw-items-center tw-gap-1.5">
          <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-text-error"></span>
          {{ "needsAttention" | i18n }}
        </span>
        <span class="tw-flex tw-items-center tw-gap-1.5">
          <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-text-tertiary"></span>
          {{ "manualAccountBadge" | i18n }}
        </span>
      </div>
    </div>

    <div
      class="tw-grid tw-grid-cols-[2fr_3fr] lg:tw-grid-cols-1 sm:tw-flex tw-h-full tw-w-full tw-justify-between tw-gap-2"
    >
      <div
        id="account-details-table"
        class="account-details-table tw-flex tw-flex-col tw-gap-4 tw-overflow-hidden tw-rounded-2xl tw-bg-color-surface-page tw-px-4 gutter-bleed-column sm:tw-flex-1 lg:tw-pt-0"
      >
        <!-- Positioning context for the filter panel: sizing it against this row (not just the
             filter button) keeps it inside the overflow-hidden table column at narrow widths.
             tw-pt-1: the row sits at the top edge of that overflow-hidden column, which clipped the
             top of the filter/Fetch buttons' 2px + 2px-offset :focus-visible outline. -->
        <div
          class="tw-relative tw-grid tw-w-full tw-grid-cols-[auto_1fr] tw-items-center tw-gap-2 tw-pt-1"
        >
          <div class="tw-flex tw-shrink-0 tw-items-center tw-justify-self-start">
            <app-accounts-filter
              [manualAccountTypes]="manualAccountTypes"
              [syncedOrigins]="syncedOrigins"
              [manualTypeCounts]="manualTypeCounts()"
              [syncedOriginCounts]="syncedOriginCounts()"
              [selectedFilter]="selectedFilter"
              (filterChange)="onFilterChange($event)"
            ></app-accounts-filter>
          </div>

          <!-- tw-self-start: the filter cell is 4px taller than its button (the button's tw-mb-1), so
               a centred Fetch button sat 2px lower than it; align both to the top. -->
          <div class="tw-flex tw-justify-center tw-justify-self-center tw-self-start tw-w-full">
            <app-gloss-button
              class="tw-w-full"
              [fontClass]="
                hasPremiumSubscription()
                  ? 'tw-text-color-text-default'
                  : 'tw-text-color-text-disabled'
              "
              [options]="{
                text: 'fetchAllData' | i18n,
                fullClass:
                  'border-gradient-neuomorphic tw-shadow-elevation-card tw-bg-color-surface-page tw-box-border tw-flex tw-h-14 tw-w-full tw-items-center tw-justify-center tw-rounded-2xl tw-px-10',
                isEnabled: hasPremiumSubscription(),
                icon: 'sync-manage',
                iconClass: hasPremiumSubscription()
                  ? 'tw-h-6 tw-w-6 tw-text-color-text-action'
                  : 'tw-h-6 tw-w-6 tw-text-color-text-disabled',
                onClick: startSync.bind(this),
                testId: 'accounts-fetch-all-data',
              }"
              *appRoleScope="'GLOSS'"
            ></app-gloss-button>
          </div>
        </div>

        <div
          class="tw-flex tw-h-auto tw-w-full tw-max-w-full tw-flex-col tw-items-start tw-justify-start tw-gap-4 tw-self-stretch tw-py-2 sm:tw-w-full"
        >
          <app-loading-announcer
            [loading]="showAccountsSkeleton()"
            loadingKey="loadingAccounts"
            loadedKey="accountsLoaded"
          />
          @if (showAccountsSkeleton()) {
            <app-account-row-skeleton data-testid="manage-accounts-skeleton" />
          } @else {
            @for (card of cards(); track card.id) {
              <div
                role="button"
                tabindex="0"
                class="tw-box-border tw-flex tw-w-full tw-rounded-2xl tw-bg-color-surface-elevated tw-px-4 tw-py-3.5 tw-text-left tw-transition-colors"
                [attr.data-testid]="'account-row-' + card.id"
                [ngClass]="{
                  'tw-shadow-elevation-control': table.accountId() !== card.id,
                  'card-selected': table.accountId() === card.id,
                }"
                [attr.aria-current]="table.accountId() === card.id ? 'true' : null"
                (click)="table.onRowClicked(card.id)"
                (keydown.enter)="table.onRowClicked(card.id)"
                (keydown.space)="table.onRowClicked(card.id); $event.preventDefault()"
              >
                <app-account-list-item [card]="card"></app-account-list-item>
              </div>
            }
          }
        </div>
      </div>
      @if (table.accountId()) {
        <!-- TODO: verify on device whether the status bar overlaps the top of this panel on mobile.
             If so, apply [style.paddingTop]="'var(--safe-area-top, 0px)'" — same fix as search-bar. -->
        <!-- lg:tw-top-0 + lg:tw-bottom-0 (instead of a height/% or h-full) so the panel's own box
             always spans the full viewport — no gap exposing the accounts list underneath, and no
             dependency on 100vh/percentage viewport quirks. Clearing the bottom nav is done with
             padding-bottom instead of shrinking the box via `bottom`, so the panel's own background
             still paints all the way to the true viewport edge (immune to any rounding/timing
             mismatch in the measured nav height) and only the scrollable content is inset above the
             nav. Reads --app-menu-height, which app-menu sets to its own measured (safe-area-inclusive)
             height and clears on destroy — so the offset is 0 whenever the nav isn't actually
             rendered, instead of a hardcoded value that assumes the nav is always there. -->
        <div
          appGlossScroll
          cdkScrollable
          class="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-p-3 lg:tw-fixed lg:tw-left-0 lg:tw-top-0 lg:tw-bottom-0 lg:tw-w-full lg:tw-overflow-auto lg:tw-bg-color-surface-page lg:tw-rounded-none lg:tw-pb-[calc(var(--app-menu-height,0px)+0.75rem)] lg:tw-z-50"
        >
          <app-account-details
            [accountId]="table.accountId()"
            [transactionCount]="transactionCount()"
            (shareToCollections)="shareAccountToOrgs($event.collectionIds, $event.accountId)"
            (onBackClicked)="closeAccountDetails()"
          ></app-account-details>
        </div>
      } @else {
        <!-- No background of its own: the page behind it already paints tw-bg-color-surface-page,
             which follows the theme. The static tw-bg-dt-neutral-200 it had before has no dark
             variant and rendered a light panel in dark mode. -->
        <div
          data-testid="accounts-no-selection-placeholder"
          class="tw-flex sm:tw-hidden tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-rounded-2xl"
        >
          <img loading="lazy" src="/images/dog.png" alt="" class="tw-w-[96px] tw-h-[68px]" />
          <span class="tw-max-w-[320px] tw-text-center tw-text-sm tw-text-dt-text-secondary">
            {{ "chooseAccountPrompt" | i18n }}
          </span>
        </div>
      }
    </div>
  </div>
</div>
